import { useQuery } from 'hooks/useCustomQuery';
import getTrunks from 'API/Trunk/getTrunks';
import {
    QUERY_CACHE_TIME,
    REFETCH_INTERVAL,
} from 'pages/dashboards/v5/constants';

/**
 * Trunks on the current company, polled for the SRT card's status bar.
 *
 * Returns the raw axios response — callers filter it down to SRT trunks by
 * trunk type id.
 *
 * @param {object}  params
 * @param {string}  params.companyID
 * @param {boolean} params.enabled   False while the dashboard menu is closed.
 */
const useGetSRTTrunks = ({ companyID, enabled = true }) => {
    return useQuery({
        queryKey: ['getSRTTrunks', companyID],
        queryFn: () => getTrunks(companyID),
        cacheTime: QUERY_CACHE_TIME,
        refetchInterval: REFETCH_INTERVAL,
        enabled,
    });
};

export default useGetSRTTrunks;
